export const translations = {
  it: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      documents: "Documenti",
      folders: "Cartelle",
      emails: "Email",
      scanner: "Scansione",
      workflow: "Workflow",
      auditLog: "Registro Attività",
      settings: "Impostazioni",
      admin: "Amministrazione",
      logout: "Esci"
    },
    // Auth
    auth: {
      login: "Accedi",
      loginTo: "Accedi ad",
      email: "Email",
      password: "Password",
      loginButton: "Accedi",
      loginError: "Credenziali non valide",
      welcome: "Benvenuto in ARCO",
      subtitle: "Sistema di gestione documentale conforme alle normative svizzere"
    },
    // Dashboard
    dashboard: {
      title: "Dashboard",
      welcome: "Benvenuto",
      totalDocuments: "Documenti Totali",
      totalFolders: "Cartelle",
      storageUsed: "Spazio Utilizzato",
      recentActivity: "Attività Recente",
      recentDocuments: "Documenti Recenti",
      noDocuments: "Nessun documento",
      uploadFirst: "Carica il tuo primo documento"
    },
    // Documents
    documents: {
      title: "Documenti",
      upload: "Carica Documento",
      search: "Cerca documenti...",
      searchHint: "Cerca per nome o tag",
      name: "Nome",
      size: "Dimensione",
      date: "Data",
      hash: "Hash SHA-256",
      version: "Versione",
      actions: "Azioni",
      download: "Scarica",
      delete: "Elimina",
      view: "Visualizza",
      preview: "Anteprima",
      tags: "Tag",
      tagsPlaceholder: "Inserisci tag separati da virgola",
      tagsHint: "Es: fattura, 2024, cliente-abc",
      tagsHelp: "Inserisci i tag separati da virgola",
      dropzone: "Trascina i file qui o clicca per selezionare",
      dropFiles: "Trascina i file qui",
      orClick: "oppure clicca per selezionare",
      dropzoneActive: "Rilascia i file qui...",
      uploading: "Caricamento in corso...",
      uploadSuccess: "Documento caricato con successo",
      deleteConfirm: "Sei sicuro di voler eliminare questo documento?",
      noDocuments: "Nessun documento in questa cartella",
      noPreview: "Anteprima non disponibile per questo tipo di file",
      dwgNotSupported: "I file DWG richiedono conversione. Usa un convertitore esterno per ottenere il formato DXF.",
      cadPreview: "I file CAD vengono convertiti in PDF per l'anteprima",
      selectFolder: "Seleziona cartella",
      uploadAndTag: "Carica con Tag",
      editTags: "Modifica Tag",
      tagsUpdated: "Tag aggiornati con successo",
      suggestedTags: "Tag suggeriti",
      filterByTags: "Filtra per tag",
      matchAll: "Tutti i tag",
      matchAny: "Almeno un tag",
      clearFilter: "Rimuovi filtro",
      activeFilters: "Filtri attivi",
      pdfa: "PDF/A",
      pdfaAvailable: "Versione PDF/A disponibile",
      pdfaNotAvailable: "PDF/A non disponibile",
      downloadPdfa: "Scarica PDF/A",
      previewPdfa: "Anteprima PDF/A",
      pdfaVersion: "PDF/A-1b",
      pdfaSize: "Dimensione PDF/A",
      originalFile: "File Originale",
      archiveVersion: "Versione Archivio",
      documentType: "Tipo Documento",
      classification: "Classificazione",
      confidence: "Confidenza",
      // Versioning
      versionHistory: "Storico Versioni",
      currentVersion: "Versione Attuale",
      previousVersions: "Versioni Precedenti",
      versionNumber: "Versione",
      versionDate: "Data Versione",
      versionBy: "Caricato da",
      downloadVersion: "Scarica questa versione",
      viewVersions: "Storico versioni",
      noVersions: "Nessuna versione precedente",
      duplicateDetected: "File già esistente",
      duplicateMessage: "Un file con lo stesso nome esiste già in questa cartella. Vuoi aggiornarlo con una nuova versione?",
      duplicateSameContent: "Il file che stai caricando è identico a quello esistente.",
      updateVersion: "Aggiorna versione",
      keepBoth: "Tieni entrambi",
      skipFile: "Salta",
      versionUpdated: "Documento aggiornato alla versione",
      types: {
        fattura: "Fattura",
        contratto: "Contratto",
        ddt: "DDT",
        preventivo: "Preventivo",
        ordine: "Ordine",
        nota_credito: "Nota di Credito",
        altro: "Altro"
      },
      workflowStatus: {
        draft: "Bozza",
        pending: "In revisione",
        changes_requested: "Richieste modifiche",
        approved: "Approvato",
        archived: "Archiviato",
        rejected: "Rifiutato",
        none: "—"
      },
      status: "Stato"
    },
    // Folders
    folders: {
      title: "Cartelle",
      create: "Nuova Cartella",
      name: "Nome",
      description: "Descrizione",
      documents: "Documenti",
      subfolders: "Sottocartelle",
      created: "Creata il",
      edit: "Modifica",
      delete: "Elimina",
      open: "Apri",
      back: "Indietro",
      deleteConfirm: "Sei sicuro di voler eliminare questa cartella?",
      noFolders: "Nessuna cartella",
      noSubfolders: "Nessuna sottocartella",
      createFirst: "Crea la tua prima cartella",
      root: "Cartella principale",
      parentFolder: "Cartella padre",
      currentFolder: "Cartella corrente",
      documentsInFolder: "Documenti nella cartella",
      searchInFolder: "Cerca in questa cartella...",
      moveToFolder: "Sposta nella cartella",
      moveDocument: "Sposta documento",
      documentMoved: "Documento spostato con successo",
      dropHere: "Rilascia qui per spostare",
      gridView: "Vista griglia",
      treeView: "Vista ad albero",
      treeStructure: "Struttura cartelle",
      expandAll: "Espandi tutto",
      collapseAll: "Comprimi tutto"
    },
    // Audit Log
    audit: {
      title: "Registro Attività",
      action: "Azione",
      resource: "Risorsa",
      user: "Utente",
      timestamp: "Data/Ora",
      details: "Dettagli",
      export: "Esporta",
      exportTitle: "Esporta Registro Attività",
      dateFrom: "Data inizio",
      dateTo: "Data fine",
      exportButton: "Esporta CSV",
      all: "Tutti",
      actions: {
        login: "Accesso",
        upload: "Caricamento",
        download: "Download",
        download_pdfa: "Download PDF/A",
        delete: "Eliminazione",
        create: "Creazione",
        update: "Modifica",
        view: "Visualizzazione",
        password_change: "Cambio Password",
        export: "Esportazione",
        export_archive: "Esportazione Archivio",
        move: "Spostamento",
        scan: "Scansione",
        workflow_submit: "Invio per Approvazione",
        workflow_approve: "Approvazione",
        workflow_reject: "Rifiuto",
        workflow_request_changes: "Richiesta Modifiche",
        workflow_resubmit: "Reinvio per Approvazione",
        email_upload: "Caricamento Email",
        email_delete: "Eliminazione Email",
        email_download: "Download Email"
      },
      resources: {
        document: "Documento",
        folder: "Cartella",
        user: "Utente",
        client: "Cliente",
        audit_log: "Registro Attività",
        email: "Email",
        workflow: "Workflow"
      }
    },
    // Scanner
    scanner: {
      title: "Scansione Documenti",
      subtitle: "Carica documenti scansionati per l'elaborazione OCR",
      uploadScan: "Carica Scansione",
      dropzone: "Trascina qui il documento scansionato o clicca per selezionare",
      dropzoneActive: "Rilascia il file qui...",
      processing: "Elaborazione in corso...",
      ocrLanguage: "Lingua OCR",
      extractInvoice: "Estrai dati fattura",
      selectFolder: "Salva nella cartella",
      tags: "Tag aggiuntivi",
      preview: "Anteprima",
      ocrResult: "Testo Estratto (OCR)",
      invoiceData: "Dati Fattura Estratti",
      noTextFound: "Nessun testo rilevato",
      saveDocument: "Salva Documento",
      newScan: "Nuova Scansione",
      recentScans: "Scansioni Recenti",
      viewDetails: "Visualizza Dettagli",
      editInvoiceData: "Modifica Dati Fattura",
      invoiceFields: {
        supplier: "Fornitore",
        invoiceNumber: "Numero Fattura",
        invoiceDate: "Data Fattura",
        dueDate: "Data Scadenza",
        subtotal: "Imponibile",
        vatRate: "Aliquota IVA",
        vatAmount: "Importo IVA",
        totalAmount: "Totale",
        currency: "Valuta",
        iban: "IBAN",
        reference: "Riferimento"
      },
      scanSuccess: "Documento scansionato e salvato con successo",
      scanError: "Errore durante l'elaborazione del documento"
    },
    // Settings
    settings: {
      title: "Impostazioni",
      language: "Lingua",
      changePassword: "Cambia Password",
      currentPassword: "Password Attuale",
      newPassword: "Nuova Password",
      confirmPassword: "Conferma Password",
      save: "Salva",
      passwordChanged: "Password modificata con successo"
    },
    // Admin
    admin: {
      title: "Amministrazione",
      clients: "Clienti",
      users: "Utenti",
      createClient: "Nuovo Cliente",
      createUser: "Nuovo Utente",
      clientName: "Nome Cliente",
      active: "Attivo",
      inactive: "Inattivo",
      role: "Ruolo",
      roles: {
        admin: "Amministratore",
        approver: "Approvatore",
        user: "Utente"
      }
    },
    // Emails
    emails: {
      title: "Archivio Email",
      subtitle: "Gestisci le email archiviate",
      upload: "Carica Email",
      uploadSuccess: "Email caricata con successo",
      search: "Cerca (mittente, destinatari, oggetto, tag, allegati)...",
      searchHint: "Ricerca su mittente, destinatari, oggetto, tag e nomi allegati",
      subject: "Oggetto",
      from: "Da",
      to: "A",
      date: "Data",
      attachments: "Allegati",
      noEmails: "Nessuna email archiviata",
      noAttachments: "Nessun allegato",
      noContent: "Nessun contenuto",
      dropFiles: "Trascina le email qui (.eml o .msg)",
      supportedFormats: "Formati supportati: .eml, .msg (Outlook)",
      deleteConfirm: "Eliminare questa email?",
      deleteWarning: "L'email e tutti i suoi allegati verranno eliminati permanentemente.",
      plainText: "Testo"
    },
    // Workflow
    workflow: {
      approve: "Approva",
      reject: "Rifiuta",
      requestChanges: "Richiedi modifiche",
      resubmit: "Reinvia",
      approveDocument: "Approva documento",
      rejectDocument: "Rifiuta documento",
      requestChangesDocument: "Richiedi modifiche al documento",
      notesOptional: "Note (opzionali)",
      notesRequired: "Note (obbligatorie)",
      notesPlaceholderOptional: "Aggiungi note opzionali...",
      notesPlaceholderReject: "Indica il motivo del rifiuto...",
      notesPlaceholderChanges: "Descrivi le modifiche richieste...",
      errorRejectReason: "Inserisci il motivo del rifiuto",
      errorChangesReason: "Descrivi le modifiche richieste",
      approveSuccess: "Documento approvato con successo",
      rejectSuccess: "Documento rifiutato",
      changesRequestedSuccess: "Richiesta modifiche inviata",
      historySubmitted: "Inviato per approvazione",
      historyResubmitted: "Reinviato per approvazione",
      historyApproved: "Approvato",
      historyRejected: "Rifiutato",
      historyChangesRequested: "Richieste modifiche"
    },
    // Meta Note
    metanote: {
      title: "Meta Note",
      select: "Seleziona",
      text: "Testo",
      highlight: "Evidenziatore",
      freehand: "Mano libera",
      eraser: "Gomma",
      color: "Colore",
      stroke: "Tratto",
      fontSize: "Dim. testo",
      opacity: "Opacità",
      deleteSelected: "Elimina selezionato",
      clearPage: "Cancella pagina",
      confirmClearPage: "Eliminare tutte le annotazioni di questa pagina?",
      lastSaved: "Ultimo salvataggio",
      page: "Pagina",
      annotationsOnPage: "annotazioni su questa pagina",
      enterText: "Inserisci testo...",
      openMetaNote: "Meta Note",
      hideAnnotations: "Nascondi",
      showAnnotations: "Mostra",
      editing: "Modifica",
      new: "Nuova nota",
      unsavedChanges: "Hai modifiche non salvate. Vuoi uscire senza salvare?"
    },
    // Common
    common: {
      save: "Salva",
      saving: "Salvataggio...",
      cancel: "Annulla",
      confirm: "Conferma",
      delete: "Elimina",
      edit: "Modifica",
      create: "Crea",
      close: "Chiudi",
      view: "Visualizza",
      download: "Scarica",
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      noData: "Nessun dato disponibile",
      back: "Indietro",
      bytes: "byte",
      kb: "KB",
      mb: "MB",
      gb: "GB",
      processing: "Elaborazione..."
    }
  },
  de: {
    nav: {
      dashboard: "Dashboard",
      documents: "Dokumente",
      folders: "Ordner",
      emails: "E-Mails",
      scanner: "Scannen",
      workflow: "Workflow",
      auditLog: "Aktivitätsprotokoll",
      settings: "Einstellungen",
      admin: "Administration",
      logout: "Abmelden"
    },
    auth: {
      login: "Anmelden",
      loginTo: "Anmelden bei",
      email: "E-Mail",
      password: "Passwort",
      loginButton: "Anmelden",
      loginError: "Ungültige Anmeldedaten",
      welcome: "Willkommen bei ARCO",
      subtitle: "Dokumentenmanagementsystem konform mit Schweizer Vorschriften"
    },
    dashboard: {
      title: "Dashboard",
      welcome: "Willkommen",
      totalDocuments: "Gesamtdokumente",
      totalFolders: "Ordner",
      storageUsed: "Verwendeter Speicher",
      recentActivity: "Letzte Aktivität",
      recentDocuments: "Neueste Dokumente",
      noDocuments: "Keine Dokumente",
      uploadFirst: "Laden Sie Ihr erstes Dokument hoch"
    },
    documents: {
      title: "Dokumente",
      upload: "Dokument hochladen",
      search: "Dokumente suchen...",
      searchHint: "Nach Name oder Tag suchen",
      name: "Name",
      size: "Größe",
      date: "Datum",
      hash: "SHA-256 Hash",
      version: "Version",
      actions: "Aktionen",
      download: "Herunterladen",
      delete: "Löschen",
      view: "Anzeigen",
      preview: "Vorschau",
      tags: "Tags",
      tagsPlaceholder: "Tags durch Komma getrennt eingeben",
      tagsHint: "Z.B.: rechnung, 2024, kunde-abc",
      tagsHelp: "Tags durch Komma getrennt eingeben",
      dropzone: "Dateien hier ablegen oder klicken zum Auswählen",
      dropFiles: "Dateien hier ablegen",
      orClick: "oder klicken zum Auswählen",
      dropzoneActive: "Dateien hier ablegen...",
      uploading: "Wird hochgeladen...",
      uploadSuccess: "Dokument erfolgreich hochgeladen",
      deleteConfirm: "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
      noDocuments: "Keine Dokumente in diesem Ordner",
      noPreview: "Vorschau für diesen Dateityp nicht verfügbar",
      dwgNotSupported: "DWG-Dateien erfordern Konvertierung. Verwenden Sie einen externen Konverter für das DXF-Format.",
      cadPreview: "CAD-Dateien werden für die Vorschau in PDF konvertiert",
      selectFolder: "Ordner auswählen",
      uploadAndTag: "Mit Tags hochladen",
      editTags: "Tags bearbeiten",
      tagsUpdated: "Tags erfolgreich aktualisiert",
      suggestedTags: "Vorgeschlagene Tags",
      filterByTags: "Nach Tags filtern",
      matchAll: "Alle Tags",
      matchAny: "Mindestens ein Tag",
      clearFilter: "Filter entfernen",
      activeFilters: "Aktive Filter",
      pdfa: "PDF/A",
      pdfaAvailable: "PDF/A-Version verfügbar",
      pdfaNotAvailable: "PDF/A nicht verfügbar",
      downloadPdfa: "PDF/A herunterladen",
      previewPdfa: "PDF/A-Vorschau",
      pdfaVersion: "PDF/A-1b",
      pdfaSize: "PDF/A-Größe",
      originalFile: "Originaldatei",
      archiveVersion: "Archivversion",
      documentType: "Dokumenttyp",
      classification: "Klassifizierung",
      confidence: "Konfidenz",
      types: {
        fattura: "Rechnung",
        contratto: "Vertrag",
        ddt: "Lieferschein",
        preventivo: "Angebot",
        ordine: "Bestellung",
        nota_credito: "Gutschrift",
        altro: "Sonstige"
      },
      // Versioning
      versionHistory: "Versionshistorie",
      currentVersion: "Aktuelle Version",
      previousVersions: "Vorherige Versionen",
      versionNumber: "Version",
      versionDate: "Versionsdatum",
      versionBy: "Hochgeladen von",
      downloadVersion: "Diese Version herunterladen",
      viewVersions: "Versionshistorie",
      noVersions: "Keine vorherigen Versionen",
      duplicateDetected: "Datei existiert bereits",
      duplicateMessage: "Eine Datei mit diesem Namen existiert bereits in diesem Ordner. Möchten Sie sie mit einer neuen Version aktualisieren?",
      duplicateSameContent: "Die Datei ist identisch mit der vorhandenen.",
      updateVersion: "Version aktualisieren",
      keepBoth: "Beide behalten",
      skipFile: "Überspringen",
      versionUpdated: "Dokument auf Version aktualisiert",
      workflowStatus: {
        draft: "Entwurf",
        pending: "In Prüfung",
        changes_requested: "Änderungen angefordert",
        approved: "Genehmigt",
        archived: "Archiviert",
        rejected: "Abgelehnt",
        none: "—"
      },
      status: "Status"
    },
    folders: {
      title: "Ordner",
      create: "Neuer Ordner",
      name: "Name",
      description: "Beschreibung",
      documents: "Dokumente",
      subfolders: "Unterordner",
      created: "Erstellt am",
      edit: "Bearbeiten",
      delete: "Löschen",
      open: "Öffnen",
      back: "Zurück",
      deleteConfirm: "Sind Sie sicher, dass Sie diesen Ordner löschen möchten?",
      noFolders: "Keine Ordner",
      noSubfolders: "Keine Unterordner",
      createFirst: "Erstellen Sie Ihren ersten Ordner",
      root: "Hauptordner",
      parentFolder: "Übergeordneter Ordner",
      currentFolder: "Aktueller Ordner",
      gridView: "Rasteransicht",
      treeView: "Baumansicht",
      treeStructure: "Ordnerstruktur",
      expandAll: "Alle erweitern",
      collapseAll: "Alle reduzieren"
    },
    audit: {
      title: "Aktivitätsprotokoll",
      action: "Aktion",
      resource: "Ressource",
      user: "Benutzer",
      timestamp: "Datum/Zeit",
      details: "Details",
      export: "Exportieren",
      exportTitle: "Aktivitätsprotokoll exportieren",
      dateFrom: "Startdatum",
      dateTo: "Enddatum",
      exportButton: "CSV exportieren",
      all: "Alle",
      actions: {
        login: "Anmeldung",
        upload: "Hochladen",
        download: "Herunterladen",
        download_pdfa: "PDF/A Herunterladen",
        delete: "Löschen",
        create: "Erstellen",
        update: "Ändern",
        view: "Anzeigen",
        password_change: "Passwortänderung",
        export: "Exportieren",
        export_archive: "Archiv Exportieren",
        move: "Verschieben",
        scan: "Scannen",
        workflow_submit: "Zur Genehmigung einreichen",
        workflow_approve: "Genehmigung",
        workflow_reject: "Ablehnung",
        workflow_request_changes: "Änderungen anfordern",
        workflow_resubmit: "Erneut einreichen",
        email_upload: "E-Mail Hochladen",
        email_delete: "E-Mail Löschen",
        email_download: "E-Mail Herunterladen"
      },
      resources: {
        document: "Dokument",
        folder: "Ordner",
        user: "Benutzer",
        client: "Kunde",
        audit_log: "Aktivitätsprotokoll",
        email: "E-Mail",
        workflow: "Workflow"
      }
    },
    settings: {
      title: "Einstellungen",
      language: "Sprache",
      changePassword: "Passwort ändern",
      currentPassword: "Aktuelles Passwort",
      newPassword: "Neues Passwort",
      confirmPassword: "Passwort bestätigen",
      save: "Speichern",
      passwordChanged: "Passwort erfolgreich geändert"
    },
    admin: {
      title: "Administration",
      clients: "Kunden",
      users: "Benutzer",
      createClient: "Neuer Kunde",
      createUser: "Neuer Benutzer",
      clientName: "Kundenname",
      active: "Aktiv",
      inactive: "Inaktiv",
      role: "Rolle",
      roles: {
        admin: "Administrator",
        approver: "Genehmiger",
        user: "Benutzer"
      }
    },
    scanner: {
      title: "Dokumentenscan",
      subtitle: "Gescannte Dokumente für OCR-Verarbeitung hochladen",
      uploadScan: "Scan hochladen",
      dropzone: "Gescanntes Dokument hier ablegen oder klicken zum Auswählen",
      dropzoneActive: "Datei hier ablegen...",
      processing: "Verarbeitung...",
      ocrLanguage: "OCR-Sprache",
      extractInvoice: "Rechnungsdaten extrahieren",
      selectFolder: "Im Ordner speichern",
      tags: "Zusätzliche Tags",
      preview: "Vorschau",
      ocrResult: "Extrahierter Text (OCR)",
      invoiceData: "Extrahierte Rechnungsdaten",
      noTextFound: "Kein Text erkannt",
      saveDocument: "Dokument speichern",
      newScan: "Neuer Scan",
      recentScans: "Letzte Scans",
      viewDetails: "Details anzeigen",
      editInvoiceData: "Rechnungsdaten bearbeiten",
      invoiceFields: {
        supplier: "Lieferant",
        invoiceNumber: "Rechnungsnummer",
        invoiceDate: "Rechnungsdatum",
        dueDate: "Fälligkeitsdatum",
        subtotal: "Nettobetrag",
        vatRate: "MwSt-Satz",
        vatAmount: "MwSt-Betrag",
        totalAmount: "Gesamtbetrag",
        currency: "Währung",
        iban: "IBAN",
        reference: "Referenz"
      },
      scanSuccess: "Dokument erfolgreich gescannt und gespeichert",
      scanError: "Fehler bei der Dokumentenverarbeitung"
    },
    emails: {
      title: "E-Mail-Archiv",
      subtitle: "Verwalten Sie archivierte E-Mails",
      upload: "E-Mail hochladen",
      uploadSuccess: "E-Mail erfolgreich hochgeladen",
      search: "Suchen (Absender, Empfänger, Betreff, Tags, Anhänge)...",
      searchHint: "Suche nach Absender, Empfänger, Betreff, Tags und Anhängen",
      subject: "Betreff",
      from: "Von",
      to: "An",
      date: "Datum",
      attachments: "Anhänge",
      noEmails: "Keine archivierten E-Mails",
      noAttachments: "Keine Anhänge",
      noContent: "Kein Inhalt",
      dropFiles: "E-Mails hierher ziehen (.eml oder .msg)",
      supportedFormats: "Unterstützte Formate: .eml, .msg (Outlook)",
      deleteConfirm: "Diese E-Mail löschen?",
      deleteWarning: "Die E-Mail und alle Anhänge werden dauerhaft gelöscht.",
      plainText: "Text"
    },
    workflow: {
      approve: "Genehmigen",
      reject: "Ablehnen",
      requestChanges: "Änderungen anfordern",
      resubmit: "Erneut einreichen",
      approveDocument: "Dokument genehmigen",
      rejectDocument: "Dokument ablehnen",
      requestChangesDocument: "Änderungen am Dokument anfordern",
      notesOptional: "Notizen (optional)",
      notesRequired: "Notizen (erforderlich)",
      notesPlaceholderOptional: "Optionale Notizen hinzufügen...",
      notesPlaceholderReject: "Geben Sie den Ablehnungsgrund an...",
      notesPlaceholderChanges: "Beschreiben Sie die erforderlichen Änderungen...",
      errorRejectReason: "Geben Sie den Ablehnungsgrund an",
      errorChangesReason: "Beschreiben Sie die erforderlichen Änderungen",
      approveSuccess: "Dokument erfolgreich genehmigt",
      rejectSuccess: "Dokument abgelehnt",
      changesRequestedSuccess: "Änderungsanfrage gesendet",
      historySubmitted: "Zur Genehmigung eingereicht",
      historyResubmitted: "Erneut zur Genehmigung eingereicht",
      historyApproved: "Genehmigt",
      historyRejected: "Abgelehnt",
      historyChangesRequested: "Änderungen angefordert"
    },
    metanote: {
      title: "Meta Note",
      select: "Auswählen",
      text: "Text",
      highlight: "Textmarker",
      freehand: "Freihand",
      eraser: "Radiergummi",
      color: "Farbe",
      stroke: "Strich",
      fontSize: "Schriftgröße",
      opacity: "Deckkraft",
      deleteSelected: "Ausgewähltes löschen",
      clearPage: "Seite löschen",
      confirmClearPage: "Alle Anmerkungen auf dieser Seite löschen?",
      lastSaved: "Zuletzt gespeichert",
      page: "Seite",
      annotationsOnPage: "Anmerkungen auf dieser Seite",
      enterText: "Text eingeben...",
      openMetaNote: "Meta Note",
      hideAnnotations: "Ausblenden",
      showAnnotations: "Anzeigen",
      editing: "Bearbeiten",
      new: "Neue Notiz",
      unsavedChanges: "Sie haben ungespeicherte Änderungen. Möchten Sie ohne Speichern verlassen?"
    },
    common: {
      save: "Speichern",
      saving: "Speichern...",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      delete: "Löschen",
      edit: "Bearbeiten",
      create: "Erstellen",
      close: "Schließen",
      view: "Ansehen",
      download: "Herunterladen",
      loading: "Wird geladen...",
      error: "Fehler",
      success: "Erfolg",
      noData: "Keine Daten verfügbar",
      back: "Zurück",
      bytes: "Bytes",
      kb: "KB",
      mb: "MB",
      gb: "GB",
      processing: "Verarbeitung..."
    }
  },
  fr: {
    nav: {
      dashboard: "Tableau de bord",
      documents: "Documents",
      folders: "Dossiers",
      emails: "Emails",
      scanner: "Numérisation",
      workflow: "Workflow",
      auditLog: "Journal d'activité",
      settings: "Paramètres",
      admin: "Administration",
      logout: "Déconnexion"
    },
    auth: {
      login: "Connexion",
      loginTo: "Connexion à",
      email: "E-mail",
      password: "Mot de passe",
      loginButton: "Se connecter",
      loginError: "Identifiants invalides",
      welcome: "Bienvenue sur ARCO",
      subtitle: "Système de gestion documentaire conforme aux réglementations suisses"
    },
    dashboard: {
      title: "Tableau de bord",
      welcome: "Bienvenue",
      totalDocuments: "Documents totaux",
      totalFolders: "Dossiers",
      storageUsed: "Espace utilisé",
      recentActivity: "Activité récente",
      recentDocuments: "Documents récents",
      noDocuments: "Aucun document",
      uploadFirst: "Téléchargez votre premier document"
    },
    documents: {
      title: "Documents",
      upload: "Télécharger un document",
      search: "Rechercher des documents...",
      name: "Nom",
      size: "Taille",
      date: "Date",
      hash: "Hash SHA-256",
      version: "Version",
      actions: "Actions",
      download: "Télécharger",
      delete: "Supprimer",
      view: "Voir",
      preview: "Aperçu",
      tags: "Tags",
      tagsPlaceholder: "Entrez les tags séparés par des virgules",
      tagsHint: "Ex: facture, 2024, client-abc",
      tagsHelp: "Entrez les tags séparés par des virgules",
      dropzone: "Déposez les fichiers ici ou cliquez pour sélectionner",
      dropFiles: "Déposez les fichiers ici",
      orClick: "ou cliquez pour sélectionner",
      dropzoneActive: "Déposez les fichiers ici...",
      uploading: "Téléchargement en cours...",
      uploadSuccess: "Document téléchargé avec succès",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce document?",
      noDocuments: "Aucun document dans ce dossier",
      noPreview: "Aperçu non disponible pour ce type de fichier",
      dwgNotSupported: "Les fichiers DWG nécessitent une conversion. Utilisez un convertisseur externe pour le format DXF.",
      cadPreview: "Les fichiers CAD sont convertis en PDF pour l'aperçu",
      selectFolder: "Sélectionner le dossier",
      uploadAndTag: "Télécharger avec Tags",
      editTags: "Modifier les tags",
      tagsUpdated: "Tags mis à jour avec succès",
      suggestedTags: "Tags suggérés",
      filterByTags: "Filtrer par tags",
      matchAll: "Tous les tags",
      matchAny: "Au moins un tag",
      clearFilter: "Supprimer le filtre",
      activeFilters: "Filtres actifs",
      pdfa: "PDF/A",
      pdfaAvailable: "Version PDF/A disponible",
      pdfaNotAvailable: "PDF/A non disponible",
      downloadPdfa: "Télécharger PDF/A",
      previewPdfa: "Aperçu PDF/A",
      pdfaVersion: "PDF/A-1b",
      pdfaSize: "Taille PDF/A",
      originalFile: "Fichier original",
      archiveVersion: "Version d'archivage",
      documentType: "Type de document",
      classification: "Classification",
      confidence: "Confiance",
      types: {
        fattura: "Facture",
        contratto: "Contrat",
        ddt: "Bon de livraison",
        preventivo: "Devis",
        ordine: "Commande",
        nota_credito: "Avoir",
        altro: "Autre"
      },
      // Versioning
      versionHistory: "Historique des versions",
      currentVersion: "Version actuelle",
      previousVersions: "Versions précédentes",
      versionNumber: "Version",
      versionDate: "Date de version",
      versionBy: "Téléchargé par",
      downloadVersion: "Télécharger cette version",
      viewVersions: "Historique des versions",
      noVersions: "Aucune version précédente",
      duplicateDetected: "Fichier existant",
      duplicateMessage: "Un fichier avec ce nom existe déjà dans ce dossier. Voulez-vous le mettre à jour avec une nouvelle version?",
      duplicateSameContent: "Le fichier est identique à celui existant.",
      updateVersion: "Mettre à jour la version",
      keepBoth: "Garder les deux",
      skipFile: "Ignorer",
      versionUpdated: "Document mis à jour vers la version",
      workflowStatus: {
        draft: "Brouillon",
        pending: "En révision",
        changes_requested: "Modifications demandées",
        approved: "Approuvé",
        archived: "Archivé",
        rejected: "Rejeté",
        none: "—"
      },
      status: "Statut"
    },
    folders: {
      title: "Dossiers",
      create: "Nouveau dossier",
      name: "Nom",
      description: "Description",
      documents: "Documents",
      created: "Créé le",
      edit: "Modifier",
      delete: "Supprimer",
      open: "Ouvrir",
      back: "Retour",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce dossier?",
      noFolders: "Aucun dossier",
      noSubfolders: "Aucun sous-dossier",
      createFirst: "Créez votre premier dossier",
      root: "Dossier principal",
      parentFolder: "Dossier parent",
      currentFolder: "Dossier actuel",
      subfolders: "Sous-dossiers",
      gridView: "Vue en grille",
      treeView: "Vue arborescente",
      treeStructure: "Structure des dossiers",
      expandAll: "Tout développer",
      collapseAll: "Tout réduire"
    },
    audit: {
      title: "Journal d'activité",
      action: "Action",
      resource: "Ressource",
      user: "Utilisateur",
      timestamp: "Date/Heure",
      details: "Détails",
      export: "Exporter",
      exportTitle: "Exporter le journal d'activité",
      dateFrom: "Date de début",
      dateTo: "Date de fin",
      exportButton: "Exporter CSV",
      all: "Tous",
      actions: {
        login: "Connexion",
        upload: "Téléchargement",
        download: "Téléchargement",
        download_pdfa: "Télécharger PDF/A",
        delete: "Suppression",
        create: "Création",
        update: "Modification",
        view: "Visualisation",
        password_change: "Changement de mot de passe",
        export: "Exportation",
        export_archive: "Exportation Archive",
        move: "Déplacement",
        scan: "Numérisation",
        workflow_submit: "Soumission pour approbation",
        workflow_approve: "Approbation",
        workflow_reject: "Rejet",
        workflow_request_changes: "Demander des modifications",
        workflow_resubmit: "Resoumettre pour approbation",
        email_upload: "Téléchargement email",
        email_delete: "Suppression email",
        email_download: "Téléchargement email"
      },
      resources: {
        document: "Document",
        folder: "Dossier",
        user: "Utilisateur",
        client: "Client",
        audit_log: "Journal d'activité",
        email: "Email",
        workflow: "Workflow"
      }
    },
    settings: {
      title: "Paramètres",
      language: "Langue",
      changePassword: "Changer le mot de passe",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      save: "Enregistrer",
      passwordChanged: "Mot de passe modifié avec succès"
    },
    admin: {
      title: "Administration",
      clients: "Clients",
      users: "Utilisateurs",
      createClient: "Nouveau client",
      createUser: "Nouvel utilisateur",
      clientName: "Nom du client",
      active: "Actif",
      inactive: "Inactif",
      role: "Rôle",
      roles: {
        admin: "Administrateur",
        approver: "Approbateur",
        user: "Utilisateur"
      }
    },
    scanner: {
      title: "Numérisation de Documents",
      subtitle: "Télécharger des documents numérisés pour le traitement OCR",
      uploadScan: "Télécharger le scan",
      dropzone: "Déposer le document numérisé ici ou cliquer pour sélectionner",
      dropzoneActive: "Déposer le fichier ici...",
      processing: "Traitement en cours...",
      ocrLanguage: "Langue OCR",
      extractInvoice: "Extraire les données de facture",
      selectFolder: "Enregistrer dans le dossier",
      tags: "Tags supplémentaires",
      preview: "Aperçu",
      ocrResult: "Texte extrait (OCR)",
      invoiceData: "Données de facture extraites",
      noTextFound: "Aucun texte détecté",
      saveDocument: "Enregistrer le document",
      newScan: "Nouvelle numérisation",
      recentScans: "Numérisations récentes",
      viewDetails: "Voir les détails",
      editInvoiceData: "Modifier les données de facture",
      invoiceFields: {
        supplier: "Fournisseur",
        invoiceNumber: "Numéro de facture",
        invoiceDate: "Date de facture",
        dueDate: "Date d'échéance",
        subtotal: "Sous-total HT",
        vatRate: "Taux de TVA",
        vatAmount: "Montant TVA",
        totalAmount: "Total",
        currency: "Devise",
        iban: "IBAN",
        reference: "Référence"
      },
      scanSuccess: "Document numérisé et enregistré avec succès",
      scanError: "Erreur lors du traitement du document"
    },
    emails: {
      title: "Archive d'emails",
      subtitle: "Gérer les emails archivés",
      upload: "Télécharger un email",
      uploadSuccess: "Email téléchargé avec succès",
      search: "Rechercher (expéditeur, destinataires, objet, tags, pièces jointes)...",
      searchHint: "Recherche par expéditeur, destinataires, objet, tags et noms de pièces jointes",
      subject: "Objet",
      from: "De",
      to: "À",
      date: "Date",
      attachments: "Pièces jointes",
      noEmails: "Aucun email archivé",
      noAttachments: "Aucune pièce jointe",
      noContent: "Aucun contenu",
      dropFiles: "Déposez les emails ici (.eml ou .msg)",
      supportedFormats: "Formats supportés: .eml, .msg (Outlook)",
      deleteConfirm: "Supprimer cet email?",
      deleteWarning: "L'email et toutes ses pièces jointes seront supprimés définitivement.",
      plainText: "Texte"
    },
    workflow: {
      approve: "Approuver",
      reject: "Rejeter",
      requestChanges: "Demander des modifications",
      resubmit: "Resoumettre",
      approveDocument: "Approuver le document",
      rejectDocument: "Rejeter le document",
      requestChangesDocument: "Demander des modifications au document",
      notesOptional: "Notes (optionnelles)",
      notesRequired: "Notes (obligatoires)",
      notesPlaceholderOptional: "Ajouter des notes optionnelles...",
      notesPlaceholderReject: "Indiquez le motif du rejet...",
      notesPlaceholderChanges: "Décrivez les modifications requises...",
      errorRejectReason: "Indiquez le motif du rejet",
      errorChangesReason: "Décrivez les modifications requises",
      approveSuccess: "Document approuvé avec succès",
      rejectSuccess: "Document rejeté",
      changesRequestedSuccess: "Demande de modifications envoyée",
      historySubmitted: "Soumis pour approbation",
      historyResubmitted: "Resoumis pour approbation",
      historyApproved: "Approuvé",
      historyRejected: "Rejeté",
      historyChangesRequested: "Modifications demandées"
    },
    metanote: {
      title: "Meta Note",
      select: "Sélectionner",
      text: "Texte",
      highlight: "Surligneur",
      freehand: "Main libre",
      eraser: "Gomme",
      color: "Couleur",
      stroke: "Trait",
      fontSize: "Taille police",
      opacity: "Opacité",
      deleteSelected: "Supprimer sélection",
      clearPage: "Effacer page",
      confirmClearPage: "Supprimer toutes les annotations de cette page?",
      lastSaved: "Dernière sauvegarde",
      page: "Page",
      annotationsOnPage: "annotations sur cette page",
      enterText: "Entrez le texte...",
      openMetaNote: "Meta Note",
      hideAnnotations: "Masquer",
      showAnnotations: "Afficher",
      editing: "Modification",
      new: "Nouvelle note",
      unsavedChanges: "Vous avez des modifications non enregistrées. Voulez-vous quitter sans enregistrer?"
    },
    common: {
      save: "Enregistrer",
      saving: "Enregistrement...",
      cancel: "Annuler",
      confirm: "Confirmer",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Créer",
      close: "Fermer",
      view: "Voir",
      download: "Télécharger",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      noData: "Aucune donnée disponible",
      back: "Retour",
      bytes: "octets",
      kb: "Ko",
      mb: "Mo",
      gb: "Go",
      processing: "Traitement..."
    }
  },
  en: {
    nav: {
      dashboard: "Dashboard",
      documents: "Documents",
      folders: "Folders",
      emails: "Emails",
      scanner: "Scanner",
      workflow: "Workflow",
      auditLog: "Activity Log",
      settings: "Settings",
      admin: "Administration",
      logout: "Logout"
    },
    auth: {
      login: "Login",
      loginTo: "Login to",
      email: "Email",
      password: "Password",
      loginButton: "Sign In",
      loginError: "Invalid credentials",
      welcome: "Welcome to ARCO",
      subtitle: "Document management system compliant with Swiss regulations"
    },
    dashboard: {
      title: "Dashboard",
      welcome: "Welcome",
      totalDocuments: "Total Documents",
      totalFolders: "Folders",
      storageUsed: "Storage Used",
      recentActivity: "Recent Activity",
      recentDocuments: "Recent Documents",
      noDocuments: "No documents",
      uploadFirst: "Upload your first document"
    },
    documents: {
      title: "Documents",
      upload: "Upload Document",
      search: "Search documents...",
      searchHint: "Search by name or tag",
      name: "Name",
      size: "Size",
      date: "Date",
      hash: "SHA-256 Hash",
      version: "Version",
      actions: "Actions",
      download: "Download",
      delete: "Delete",
      view: "View",
      preview: "Preview",
      tags: "Tags",
      tagsPlaceholder: "Enter tags separated by commas",
      tagsHint: "E.g.: invoice, 2024, client-abc",
      tagsHelp: "Enter tags separated by commas",
      dropzone: "Drag files here or click to select",
      dropFiles: "Drag files here",
      orClick: "or click to select",
      dropzoneActive: "Drop files here...",
      uploading: "Uploading...",
      uploadSuccess: "Document uploaded successfully",
      deleteConfirm: "Are you sure you want to delete this document?",
      noDocuments: "No documents in this folder",
      noPreview: "Preview not available for this file type",
      dwgNotSupported: "DWG files require conversion. Use an external converter for DXF format.",
      cadPreview: "CAD files are converted to PDF for preview",
      selectFolder: "Select folder",
      uploadAndTag: "Upload with Tags",
      editTags: "Edit Tags",
      tagsUpdated: "Tags updated successfully",
      suggestedTags: "Suggested tags",
      filterByTags: "Filter by tags",
      matchAll: "All tags",
      matchAny: "Any tag",
      clearFilter: "Clear filter",
      activeFilters: "Active filters",
      pdfa: "PDF/A",
      pdfaAvailable: "PDF/A version available",
      pdfaNotAvailable: "PDF/A not available",
      downloadPdfa: "Download PDF/A",
      previewPdfa: "Preview PDF/A",
      pdfaVersion: "PDF/A-1b",
      pdfaSize: "PDF/A Size",
      originalFile: "Original File",
      archiveVersion: "Archive Version",
      documentType: "Document Type",
      classification: "Classification",
      confidence: "Confidence",
      types: {
        fattura: "Invoice",
        contratto: "Contract",
        ddt: "Delivery Note",
        preventivo: "Quote",
        ordine: "Order",
        nota_credito: "Credit Note",
        altro: "Other"
      },
      // Versioning
      versionHistory: "Version History",
      currentVersion: "Current Version",
      previousVersions: "Previous Versions",
      versionNumber: "Version",
      versionDate: "Version Date",
      versionBy: "Uploaded by",
      downloadVersion: "Download this version",
      viewVersions: "Version History",
      noVersions: "No previous versions",
      duplicateDetected: "File Already Exists",
      duplicateMessage: "A file with this name already exists in this folder. Do you want to update it with a new version?",
      duplicateSameContent: "The file is identical to the existing one.",
      updateVersion: "Update Version",
      keepBoth: "Keep Both",
      skipFile: "Skip",
      versionUpdated: "Document updated to version",
      workflowStatus: {
        draft: "Draft",
        pending: "In Review",
        changes_requested: "Changes Requested",
        approved: "Approved",
        archived: "Archived",
        rejected: "Rejected",
        none: "—"
      },
      status: "Status"
    },
    folders: {
      title: "Folders",
      create: "New Folder",
      name: "Name",
      description: "Description",
      documents: "Documents",
      created: "Created on",
      edit: "Edit",
      delete: "Delete",
      open: "Open",
      back: "Back",
      deleteConfirm: "Are you sure you want to delete this folder?",
      noFolders: "No folders",
      noSubfolders: "No subfolders",
      createFirst: "Create your first folder",
      root: "Root folder",
      parentFolder: "Parent folder",
      currentFolder: "Current folder",
      subfolders: "Subfolders",
      gridView: "Grid view",
      treeView: "Tree view",
      treeStructure: "Folder structure",
      expandAll: "Expand all",
      collapseAll: "Collapse all"
    },
    audit: {
      title: "Activity Log",
      action: "Action",
      resource: "Resource",
      user: "User",
      timestamp: "Date/Time",
      details: "Details",
      export: "Export",
      exportTitle: "Export Activity Log",
      dateFrom: "Start date",
      dateTo: "End date",
      exportButton: "Export CSV",
      all: "All",
      actions: {
        login: "Login",
        upload: "Upload",
        download: "Download",
        download_pdfa: "Download PDF/A",
        delete: "Delete",
        create: "Create",
        update: "Update",
        view: "View",
        password_change: "Password Change",
        export: "Export",
        export_archive: "Archive Export",
        move: "Move",
        scan: "Scan",
        workflow_submit: "Submit for Approval",
        workflow_approve: "Approval",
        workflow_reject: "Rejection",
        workflow_request_changes: "Request Changes",
        workflow_resubmit: "Resubmit for Approval",
        email_upload: "Email Upload",
        email_delete: "Email Delete",
        email_download: "Email Download"
      },
      resources: {
        document: "Document",
        folder: "Folder",
        user: "User",
        client: "Client",
        audit_log: "Activity Log",
        email: "Email",
        workflow: "Workflow"
      }
    },
    settings: {
      title: "Settings",
      language: "Language",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      save: "Save",
      passwordChanged: "Password changed successfully"
    },
    admin: {
      title: "Administration",
      clients: "Clients",
      users: "Users",
      createClient: "New Client",
      createUser: "New User",
      clientName: "Client Name",
      active: "Active",
      inactive: "Inactive",
      role: "Role",
      roles: {
        admin: "Administrator",
        approver: "Approver",
        user: "User"
      }
    },
    scanner: {
      title: "Document Scanner",
      subtitle: "Upload scanned documents for OCR processing",
      uploadScan: "Upload Scan",
      dropzone: "Drop scanned document here or click to select",
      dropzoneActive: "Drop the file here...",
      processing: "Processing...",
      ocrLanguage: "OCR Language",
      extractInvoice: "Extract invoice data",
      selectFolder: "Save to folder",
      tags: "Additional tags",
      preview: "Preview",
      ocrResult: "Extracted Text (OCR)",
      invoiceData: "Extracted Invoice Data",
      noTextFound: "No text detected",
      saveDocument: "Save Document",
      newScan: "New Scan",
      recentScans: "Recent Scans",
      viewDetails: "View Details",
      editInvoiceData: "Edit Invoice Data",
      invoiceFields: {
        supplier: "Supplier",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date",
        dueDate: "Due Date",
        subtotal: "Subtotal",
        vatRate: "VAT Rate",
        vatAmount: "VAT Amount",
        totalAmount: "Total Amount",
        currency: "Currency",
        iban: "IBAN",
        reference: "Reference"
      },
      scanSuccess: "Document scanned and saved successfully",
      scanError: "Error processing document"
    },
    emails: {
      title: "Email Archive",
      subtitle: "Manage archived emails",
      upload: "Upload Email",
      uploadSuccess: "Email uploaded successfully",
      search: "Search (sender, recipients, subject, tags, attachments)...",
      searchHint: "Search by sender, recipients, subject, tags and attachment names",
      subject: "Subject",
      from: "From",
      to: "To",
      date: "Date",
      attachments: "Attachments",
      noEmails: "No archived emails",
      noAttachments: "No attachments",
      noContent: "No content",
      dropFiles: "Drop emails here (.eml or .msg)",
      supportedFormats: "Supported formats: .eml, .msg (Outlook)",
      deleteConfirm: "Delete this email?",
      deleteWarning: "The email and all its attachments will be permanently deleted.",
      plainText: "Text"
    },
    workflow: {
      approve: "Approve",
      reject: "Reject",
      requestChanges: "Request Changes",
      resubmit: "Resubmit",
      approveDocument: "Approve Document",
      rejectDocument: "Reject Document",
      requestChangesDocument: "Request Changes to Document",
      notesOptional: "Notes (optional)",
      notesRequired: "Notes (required)",
      notesPlaceholderOptional: "Add optional notes...",
      notesPlaceholderReject: "Provide rejection reason...",
      notesPlaceholderChanges: "Describe required changes...",
      errorRejectReason: "Please provide a rejection reason",
      errorChangesReason: "Please describe the required changes",
      approveSuccess: "Document approved successfully",
      rejectSuccess: "Document rejected",
      changesRequestedSuccess: "Change request sent",
      historySubmitted: "Submitted for approval",
      historyResubmitted: "Resubmitted for approval",
      historyApproved: "Approved",
      historyRejected: "Rejected",
      historyChangesRequested: "Changes requested"
    },
    metanote: {
      title: "Meta Note",
      select: "Select",
      text: "Text",
      highlight: "Highlighter",
      freehand: "Freehand",
      eraser: "Eraser",
      color: "Color",
      stroke: "Stroke",
      fontSize: "Font size",
      opacity: "Opacity",
      deleteSelected: "Delete selected",
      clearPage: "Clear page",
      confirmClearPage: "Delete all annotations on this page?",
      lastSaved: "Last saved",
      page: "Page",
      annotationsOnPage: "annotations on this page",
      enterText: "Enter text...",
      openMetaNote: "Meta Note",
      hideAnnotations: "Hide",
      showAnnotations: "Show",
      editing: "Editing",
      new: "New note",
      unsavedChanges: "You have unsaved changes. Do you want to leave without saving?"
    },
    common: {
      save: "Save",
      saving: "Saving...",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      close: "Close",
      view: "View",
      download: "Download",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      noData: "No data available",
      back: "Back",
      bytes: "bytes",
      kb: "KB",
      mb: "MB",
      gb: "GB",
      processing: "Processing..."
    }
  }
};

export const languageNames = {
  it: "Italiano",
  de: "Deutsch",
  fr: "Français",
  en: "English"
};
